import { template as template_0d0dea28682e42d0bf75befd7cf76eef } from "@ember/template-compiler";
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default template_0d0dea28682e42d0bf75befd7cf76eef(`
  <span class="tooltip-wrapper" aria-label={{t "shared.accessibility.helpLabel"}}>
    {{svgJar "help" class="icon" aria-hidden="true"}}
    <AttachTooltip @class="tooltip align-left">
      {{yield}}
    </AttachTooltip>
  </span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
